<template>
  <list-item
    :link="{ path: `/billboard/${booking.id}` }"
    :booking="booking"
  >
    <template v-if="$userIsAdmin && bookingHasTalentResponses" v-slot:bids>
      <span data-test-id="numberBids" class="list-item__bids">
        {{ booking.talent_response_count }}
      </span>
    </template>

    <template v-slot:categories>
      <div v-if="booking.opportunities.length" class="flex flex-wrap">
        <span v-for="opp in booking.opportunities" :key="opp.id" class="label label-info">{{ opp.name }}</span>
      </div>
    </template>

    <template v-slot:status>
      <div class="spacer-b-2" v-if="booking.urgent" >
        <span class="label label-danger">Urgent</span>
      </div>
    </template>

    <template v-slot:applications>
      <template v-if="$userIsTalent || $userIsManager">
        <span data-test-id="hasApplied" class="label label-success" v-if="talentHasAppliedForBooking">
          {{ $declineModuleEnabled ? $t('Applied') : 'Accepted' }}
          <template v-if="$userIsManager">({{ talentAppliedForBooking }})</template>
        </span>
        <span data-test-id="hasDeclined" class="label label-danger" v-else-if="talentHasDeclinedBooking">
          Declined
          <template v-if="$userIsManager">({{ talentDeclinedBooking }})</template>
        </span>
      </template>

      <div v-else-if="talentHasMixedResponse" class="list-item__status">
        <span data-test-id="hasApplied" class="label label-success">{{ $declineModuleEnabled ? $t('Applied') : 'Accepted' }} ({{ talentAppliedForBooking }})</span>
        <span data-test-id="hasDeclined" class="label label-danger">Declined ({{ talentDeclinedBooking }})</span>
      </div>
    </template>

    <template v-slot:hero v-if="userCanSeeBudget" >
      <span v-if="$userIsTalent || $userIsManager" data-test-id="budgetPrice">
        <template v-if="booking.local_currency">
          {{ booking.local_currency_budget_per_star_as_user_rate | currency(booking.local_currency) | nullable }}
        </template>
        <template v-else>
          {{ booking.budget_per_star_as_user_rate | currency(booking.currency) | nullable }}
        </template>
      </span>
      <span v-else data-test-id="budgetPrice">
        <template v-if="booking.local_currency">
          {{ booking.local_currency_budget_per_star | currency(booking.local_currency) | nullable }}
        </template>
        <template v-else>
          {{ booking.budget_per_star | currency(booking.currency) | nullable }}
        </template>
      </span>
    </template>

    <template v-slot:admin>
      <div class="spacer-b-1 flex flex-row" v-if="booking.local_currency">
        <i class="fa fa-info-circle spacer-r-1"></i>
        <span>Estimated conversion to {{ booking.local_currency }}. Actual amount may differ due to fluctuating conversion rates.</span>
      </div>
    </template>
  </list-item>

</template>

<script>
import { helpers, talentHelpers } from 'mixins/bookings'
import ListItem from '../list/ListItem'

export default {
  mixins: [helpers, talentHelpers],
  components: {
    ListItem
  },
  props: {
    booking: {
      required: true,
      type: Object
    }
  },
  computed: {
    bookingHasTalentResponses () {
      return this.booking.talent_response_count &&
        this.booking.talent_response_count > 0
    }
  }
}
</script>
